import {
  callPeerName,
  callPeerNumber,
  useSoftphone
} from "@dialstack/sdk-react/softphone";
import { useCallback } from "react";

import useColleagueLookup, {
  colleagueLabel
} from "./use-colleague-lookup.hook";

// While a consult-first transfer is in flight the softphone parks the call
// being transferred. Returns the line that says so for that call, and null for
// every other call.
export default function useTransferStatus() {
  const { transferOriginal, consultCall } = useSoftphone();
  const parkedCallId = transferOriginal?.id ?? null;
  const targetNumber = consultCall ? callPeerNumber(consultCall) : null;
  const targetName = consultCall ? callPeerName(consultCall) : null;
  const lookupColleague = useColleagueLookup([targetNumber]);

  return useCallback(
    (callId: string) => {
      if (parkedCallId === null || parkedCallId !== callId) return null;
      const colleague = lookupColleague(targetNumber, targetName);
      const target = colleague ? colleagueLabel(colleague) : targetNumber;
      return target
        ? `On hold · transferring to ${target}`
        : "On hold · transferring";
    },
    [parkedCallId, lookupColleague, targetNumber, targetName]
  );
}
